import { normalizePath, sanitizeOperatorId, sanitizeSearchTerm, slugify, UtilService } from '@app/shared/utils';
import { OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DatadogService } from './shared/services/datadog/datadog.service';
import { SdkAnalyticsService } from './shared/services/sdk-analytics/sdk-analytics.service';
var AppComponent = /** @class */ (function () {
    function AppComponent(route, util, translate, titleService, _datadogService, _sdkAnalyticsService) {
        this.route = route;
        this.util = util;
        this.translate = translate;
        this.titleService = titleService;
        this._datadogService = _datadogService;
        this._sdkAnalyticsService = _sdkAnalyticsService;
        this.islogged = true;
        this.isLoading = true;
        this.redirectLogin = false;
        this.isHomePage = false;
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.onLangChange.subscribe(function (event) {
            // Change page title when user changes language preference
            _this.translate.get('MAINTITLE').subscribe(function (res) {
                _this.titleService.setTitle(res);
            });
        });
        this.showContent();
        this.route.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                var m_busca = event.urlAfterRedirects.match(/\/busca;searchTerm=([^;/?#]+)/);
                var m_menu = event.urlAfterRedirects.match(/\/menu;([^;/?#]+)/);
                if (m_busca && m_busca[1]) {
                    var searchTerm = m_busca ? decodeURIComponent(m_busca[1]) : null;
                    _this._sdkAnalyticsService.trackEvent('screen_view', {
                        custom_path: '/iss/busca',
                        implementation_team: 'output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente',
                    });
                    _this._sdkAnalyticsService.trackEvent('search', {
                        custom_path: "/iss/busca",
                        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                        search_term: sanitizeSearchTerm(searchTerm),
                        detail: "resultado-busca"
                    });
                }
                else if (_this.isMenuRoute(event.urlAfterRedirects)) {
                    var detail = _this.buildMenuDetailFromUrl(event.urlAfterRedirects);
                    _this._sdkAnalyticsService.trackEvent('screen_view', {
                        custom_path: '/iss/menu',
                        implementation_team: 'output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente',
                        detail: detail
                    });
                }
                else {
                    _this._sdkAnalyticsService.trackEvent('screen_view', {
                        custom_path: normalizePath(event.urlAfterRedirects),
                        implementation_team: 'output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente',
                    });
                }
                // Configurar o startView e setUser do datadog com base na rota atual
                if (_this.authUserLogged()) {
                    var authUser = JSON.parse(localStorage.getItem('authUser'));
                    var usuario = sanitizeOperatorId(_this.getUser()); //this.DDUserGerarId(this.getUser());
                    _this._datadogService.sendStartView(event.urlAfterRedirects, { idSessao: authUser.idSessao });
                    _this._datadogService.sendSetUser(usuario, authUser.gestor + '_' + authUser.idSessao);
                    _this._sdkAnalyticsService.setUserProperties({ user: {
                            operator_id: usuario,
                            employee_id: authUser.gestor
                        } });
                }
                else {
                    _this._datadogService.sendStartView(event.urlAfterRedirects);
                }
            }
        });
    };
    // tslint:disable-next-line: use-life-cycle-interface
    AppComponent.prototype.ngDoCheck = function () {
        if (this.util.isHomePageOrBrowserWarning()) {
            this.isHomePage = true;
        }
        else {
            this.isHomePage = false;
        }
    };
    AppComponent.prototype.showContent = function () {
        this.isLoading = !((sessionStorage.getItem('sessionState') === 'true' &&
            localStorage.getItem('authUser')));
        if (localStorage.getItem('authUser') == null || localStorage.getItem('authUser') == undefined) {
            this.redirectLogin = false;
            this.route.navigate(['/browser-warning']);
        }
        else {
            this.redirectLogin = this.islogged && !this.isLoading;
        }
    };
    AppComponent.prototype.getUser = function () {
        var token = localStorage.getItem('token') || '';
        var jsonDecoded = token && atob(token.split('.')[1]);
        return jsonDecoded && JSON.parse(jsonDecoded)['usuario'];
    };
    AppComponent.prototype.letraParaNumero = function (letra) {
        if (!letra || letra.trim() === '')
            return 0;
        var code = letra.toUpperCase().charCodeAt(0);
        if (code < 65 || code > 90)
            return 0;
        return code - 64;
    };
    AppComponent.prototype.DDUserGerarId = function (nome) {
        var concatenado = nome;
        var idNumerico = '';
        for (var _i = 0, concatenado_1 = concatenado; _i < concatenado_1.length; _i++) {
            var letra = concatenado_1[_i];
            var numero = this.letraParaNumero(letra);
            idNumerico += numero.toString();
        }
        return idNumerico;
    };
    AppComponent.prototype.authUserLogged = function () {
        return localStorage.getItem('authUser') != null && localStorage.getItem('authUser') !== undefined;
    };
    AppComponent.prototype.getPrimarySegments = function (url) {
        var tree = this.route.parseUrl(url);
        var primary = tree.root.children && tree.root.children['primary'];
        return primary ? primary.segments : [];
    };
    AppComponent.prototype.isMenuRoute = function (url) {
        var segments = this.getPrimarySegments(url);
        return segments.some(function (s) { return s.path === 'menu'; });
    };
    // Captura matrix params do segmento 'menu'
    AppComponent.prototype.getMenuMatrixParams = function (url) {
        var segments = this.getPrimarySegments(url);
        var menuSeg = segments.find(function (s) { return s.path === 'menu'; });
        return menuSeg ? menuSeg.parameters : {};
    };
    AppComponent.prototype.buildMenuDetailFromUrl = function (url) {
        var params = this.getMenuMatrixParams(url);
        var menuName = params.menuName ? slugify(params.menuName || '') : null;
        var category = params.category ? slugify(params.category || '') : null;
        if (menuName && category)
            return 'menu-' + menuName + ':' + category;
        if (menuName)
            return 'menu-' + menuName;
        return 'menu';
    };
    return AppComponent;
}());
export { AppComponent };
